// iter147 — `.report-scope` restores the original earthy palette inside
// every rendered report so the printed/downloaded PDF is byte-for-byte
// identical to the pre-recolour artefact (see index.css for the CSS var
// overrides).
export default function ReportShell({ title, subtitle, children, className = "", testId }) {
  return (
    <section className={`report-scope print-page ${className}`} data-testid={testId}>
      <div className="mb-6 text-center">
        <h3 className="text-2xl font-bold uppercase tracking-wide text-[#1d1d1d]">{title}</h3>
        {subtitle && <p className="mt-2 text-sm font-semibold text-[#3a3a3a]">{subtitle}</p>}
      </div>
      {children}
    </section>
  );
}
